import { Intersect, Partial, Record, Static, String } from "runtypes";

export const LoginCallbackRequestRuntype = Intersect(
  Record({
  code: String,
  }),
  Partial({ email: String })
);

export interface ILoginCallbackRequest
  extends Static<typeof LoginCallbackRequestRuntype> {}



// WEBPACK FOOTER //
// ./src/services/ILoginCallbackRequest.ts